import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { Logo } from './Logo';
import { SplashScreen } from './SplashScreen';
import { useAuth } from '../context/AuthContext';
import { apiPost } from '../utils/apiClient';

export function HouseholdAccessStartTrial() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let cancelled = false;

    if (loading) {
      return () => {
        cancelled = true;
      };
    }

    if (!user) {
      navigate('/auth/signin?next=/household-access/start-trial', { replace: true });
      return () => {
        cancelled = true;
      };
    }

    (async () => {
      try {
        await apiPost('/household-access/continue', {});
        if (!cancelled) {
          navigate('/MealPlan', { replace: true });
        }
      } catch (err) {
        console.warn('Failed to start household access trial:', err);
        if (!cancelled) {
          setErrorMessage(err?.message || 'Could not start your free trial right now.');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [loading, navigate, user]);

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,#E9F0DD_0%,#F8F7F5_42%,#F3F1EC_100%)] px-6 py-10">
      <div className="mx-auto max-w-md rounded-[32px] border border-black/10 bg-white/90 p-6 text-center shadow-[0_24px_80px_rgba(31,40,20,0.12)] backdrop-blur">
        {errorMessage && (
          <div className="mb-4 rounded-2xl border border-[#B85A5A]/30 bg-[#FEF5F5] px-4 py-3 text-left text-sm text-[#B85A5A]">
            <div className="flex items-start gap-2">
              <AlertCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#B85A5A]" />
              <p>{errorMessage}</p>
            </div>
          </div>
        )}

        <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-[#FFF4DE] shadow-sm">
          <Logo className="h-10 w-10" color="#AFBB8B" />
        </div>
        <h1 className="mb-3 text-[30px] font-semibold leading-[1.08] text-[#1F2814]">Starting your free trial</h1>
        <p className="mx-auto max-w-[30ch] text-[16px] leading-7 text-[#5A6252]">
          We’re setting up your own MealPlan Genie space now so you can continue as the owner of your own household.
        </p>
      </div>
      <SplashScreen onComplete={() => {}} />
    </div>
  );
}

export default HouseholdAccessStartTrial;